"use client";
import Link from "next/link";
import React from "react";
import { Links } from "./MenuLinks";
import { usePathname } from "next/navigation";

export default function LinksUl() {
  const pathname = usePathname();

  return (
    <ul className="  flex items-center justify-center lg:space-x-4 xl:space-x-6">
      {Links.map((link) => (
        <li
          key={link.href}
          className={`${
            pathname.includes(link.href)
              ? "bg-gradient-to-tr from-[#090EDB] to-[#E73DC4] text-white py-2 px-3 rounded-lg"
              : "text-primary"
          } text-xs xl:text-sm hover:-translate-y-1 transition-all cursor-pointer font-medium`}
        >
          <Link href={link.href} className="h-full w-full">
            {link.name}
          </Link>
        </li>
      ))}
    </ul>
  );
}
